//리포트 소개 페이지

"use client";
import React, { useEffect } from "react";
import { useSearchParams } from "next/navigation";

export default function ReportIntroduce() {
  const searchParams = useSearchParams();

  useEffect(() => {
    if (searchParams.get("alert") === "unauthorized") {
      alert("권한이 없습니다!");
    } else if (searchParams.get("alert") === "invalidaccess") {
      alert("잘못된 접근입니다!");
    }
  }, [searchParams]);

  return (
    <div className="flex flex-col gap-8 w-full h-full p-9 overflow-scroll"></div>
  );
}
